export default __webpack_public_path__ + "static/media/US.94906573.svg";